import { Button, Popconfirm, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Admin from '../../../core/models/Admin';
import tableColumnTextFilterConfig from '../../../utils/searchUtil';

interface IProps {
  isLoading: boolean;
  admins: Admin[] | undefined;
  onEdit: (admin: Admin) => void;
  onDelete: (admin: Admin) => void;
}

const AdminTable: React.FC<IProps> = ({ isLoading, admins, onEdit, onDelete }) => {
  const columns: ColumnsType<Admin> = [
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
      sorter: (a, b) => a.firstName.localeCompare(b.firstName),
      render: (text: string) => text,
      ...tableColumnTextFilterConfig<Admin>(),
      onFilter: (value, record) => {
        return record.firstName.toString().toLowerCase().includes(value.toString().toLowerCase());
      },
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
      sorter: (a, b) => a.lastName.localeCompare(b.lastName),
      render: (text: string) => text,
      ...tableColumnTextFilterConfig<Admin>(),
      onFilter: (value, record) => {
        return record.lastName.toString().toLowerCase().includes(value.toString().toLowerCase());
      },
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: (a, b) => a.email.localeCompare(b.email),
      render: (text: string) => text,
      ...tableColumnTextFilterConfig<Admin>(),
      onFilter: (value, record) => {
        return record.email.toString().toLowerCase().includes(value.toString().toLowerCase());
      },
    },
    {
      title: 'Phone Number',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      sorter: (a, b) => a.phoneNumber.localeCompare(b.phoneNumber),
      render: (text: string) => text,
      ...tableColumnTextFilterConfig<Admin>(),
      onFilter: (value, record) => {
        return record.phoneNumber.toString().toLowerCase().includes(value.toString().toLowerCase());
      },
    },
    {
      title: 'Status',
      dataIndex: ['status', 'name'],
      key: 'status',
      sorter: (a, b) => a.status.name.localeCompare(b.status.name),
      render: (text: string) => text,
      filters: [
        { text: 'Active', value: '1' },
        { text: 'Inactive', value: '2' },
      ],
      onFilter: (value, record) => {
        return record.status.id.toString().toLowerCase().includes(value.toString().toLowerCase());
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <span>
          <Popconfirm
            title='Are you sure you want to delete this admin account?'
            placement='topLeft'
            onConfirm={(event) => {
              event?.preventDefault();
              event?.stopPropagation();
              onDelete(record);
            }}
            onCancel={(event) => {
              event?.preventDefault();
              event?.stopPropagation();
            }}
            okText='Yes'
            okButtonProps={{ danger: true }}
          >
            <Button
              danger
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
              }}
            >
              Delete
            </Button>
          </Popconfirm>
        </span>
      ),
    },
  ];

  return (
    <Table
      dataSource={admins}
      columns={columns}
      rowKey='id'
      loading={isLoading}
      size='small'
      onRow={(record, rowIndex) => {
        return {
          onClick: (event) => {
            event.preventDefault();
            onEdit(record);
          },
        };
      }}
    />
  );
};

export default AdminTable;
